import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "transferCard-route__wrapper" }
const _hoisted_2 = { class: "transferCard-route__line" }
const _hoisted_3 = { class: "transferCard-route__dot-text" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "transferCard-route__icon icon-bus" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.item.TransferRouteList, (stop) => {
        return (_openBlock(), _createBlock("span", {
          class: "transferCard-route__dot",
          key: stop.Address,
          tooltip: stop.Address
        }, [
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.parseDate(stop.Date, "HH:mm")), 1)
        ], 8, ["tooltip"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _hoisted_4
  ]))
}